export default {
  matchingProfiles: {
    actions: {
      backButton: 'Zurück',
      toCandidateButton: 'Zum Kandidaten'
    },
    error: {
      loadingError: 'Fehler beim Laden der Kandidaten!',
      noData: 'Keine Daten gefunden'
    },
    title: {
      headerData: 'Persönliche Informationen',
      headerMatchingProfile: 'Matching Profil',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phoneNumber: 'Telefonnummer',
      street: 'Straße',
      birthDate: 'Geburtsdatum',
      postalCode: 'Postleitzahl',
      city: 'Stadt'
    }
  },
  searchField: {
    placeHolder: 'Matchingprofile Suche'
  },
  tableTitle: 'Matchingprofile mit Kandidateneintrag',
  tableCellHeader: {
    createdAt: 'Registriert am',
    title: 'Anrede',
    salutation: 'Anrede',
    mailAddress: 'E-Mail Adresse',
    currentJob: 'Berufsbezeichnung',
    firstName: 'Vorname',
    lastName: 'Nachname',
    mail: 'E-Mail',
    status: 'Status',
    phoneNumber: 'Telefonnummer',
    birthDate: 'Geburtsdatum',
    street: 'Straße',
    postalCode: 'PLZ',
    city: 'Stadt',
    currentCompany: 'Unternehmen',
    lastChange: 'Zuletzt aktualisiert',
    pastContact: 'Zuletzt kontaktiert'
  }
};
